import React, { useState, useRef } from "react";
import Dropzone from "react-dropzone";
import axios from "axios";

const VideoEditor = () => {
  const [videoUrl, setVideoUrl] = useState("");
  const [frames, setFrames] = useState([]);
  const [loading, setLoading] = useState(false);
  const videoRef = useRef(null);
  const frameContainerRef = useRef(null);
  

  const handleDrop = async (acceptedFiles) => {
    const file = acceptedFiles[0];
    setVideoUrl(URL.createObjectURL(file));
    setLoading(true);

    const formData = new FormData();
    formData.append("video", file);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/create-frame`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setFrames(response.data.frames);
    } catch (error) {
      console.error("Error processing video:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleTimeUpdate = () => {
    if (!videoRef.current || !frameContainerRef.current) return;

    const video = videoRef.current;
    const scrollContainer = frameContainerRef.current;

    const progress = video.currentTime / video.duration;
    const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;

    scrollContainer.scrollLeft = maxScrollLeft * progress;
  };

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <h1>Video Editor - Frame Generate</h1>
      <Dropzone onDrop={handleDrop} accept="video/*" multiple={false}>
        {({ getRootProps, getInputProps }) => (
          <div
            {...getRootProps()}
            style={{
              border: "2px dashed #cccccc",
              padding: "20px",
              marginBottom: "20px",
              cursor: "pointer",
            }}
          >
            <input {...getInputProps()} />
            <p>Drag and drop a video here, or click to select one</p>
          </div>
        )}
      </Dropzone>

      {loading && (
        <div style={{ margin: "20px", fontSize: "24px" }}>
          <p>Loading... Please wait</p>
          <div className="loader"></div>
        </div>
      )}

      {videoUrl && !loading && (
        <div>
          <video
            controls
            width="600"
            src={videoUrl}
            ref={videoRef}
            onTimeUpdate={handleTimeUpdate}
          ></video>
        </div>
      )}

      <div
        ref={frameContainerRef}
        style={{
          display: "flex",
          overflowX: "auto",
          whiteSpace: "nowrap",
          marginTop: "20px",
          paddingBottom: "10px",
          scrollbarWidth: "none",
          scrollBehavior: "smooth",
          borderBottom: "2px solid #ddd",
        }}
      >
        {frames.map((frame, index) => (
          <img
            key={index}
            src={`${process.env.REACT_APP_API_URL}${frame}`}
            alt={`Frame ${index}`}
            style={{
              flex: "0 0 auto",
              width: "100px",
              height: "auto",
              objectFit: "cover",
              marginRight: "5px",
              borderRadius: "5px",
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default VideoEditor;
